import logger from '@core/util/universal-logger';

export default function getQueue(onError) {
  const items = [];

  let busy = false;

  async function dequeue() {
    if (busy) {
      // This condition should never be true
      // but adding it here to cover any edge case
      logger.warn('Queue is already busy, skipping this "dequeue" call.');
    } else {
      busy = true;
      let func = items[0];
      if (func) {
        try {
          await func();
        } catch (err) {
          onError(err);
        } finally {
          /*
              remove the processed func from the list
              it is important that we do not remove it before processing it
              otherwise, enqueue might call dequeue while we are still processing the previous item
          */
          items.shift();
          busy = false;

          if (items.length) {
            /*
                specifically not using await in the following call
                so that it does not add to the list of the promise chain
                it will start a new promise chain
                The next dequeue call needs to happen after the finally
            */
            // process next item
            dequeue();
          }
          // avoid memory leaks
          func = null;
        }
      }
    }
  }

  return {
    enqueue(func) {
      items.push(func);

      if (items.length === 1) {
        // automatically start processing the queue
        dequeue();
      }
    },
  };
}
